
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "stopImpersonating",
      resolverType: "mutation",
      routePath: "/stopImpersonating",
      httpMethod: "POST",
    });
  